import React, { useEffect, useState,useRef  } from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import BillOfLadingFormProperties from './BillOfLadingFormProperties'
import LocalTable from '../../../components/aciacehighway/LocalTable'
import Alert from '../../../components/Alert'
import DialogForm from '../../../components/aciacehighway/DialogForm'
import { Grid, Card, Typography, Box } from '@material-ui/core'
import Namespace from '../../../constants/locale/Namespace'
import AceOcnPermitToTransferKeys from 'src/constants/locale/key/AceOcnPermitToTransfer'
import { useFormContext, useWatch } from 'react-hook-form'
import AceOcnBillofladingApiUrls from 'src/apiUrls/AceOcnBillofladingApiUrls'
import MassUpdateDialog from './MassUpdatePTTDialog'
 
const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL },
  CodeMaintenanceType
} = constants

function BillOfLadingPTTSection(props) {
  const { getValues, setValue } = useFormContext()
  const {  setBillOfLadingDirty } = props
  const [lookups, setLookups] = useState(null)
  const [dialog, setDialog] = useState({ open: false, billOfLading: null })
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const { translate } = useTranslation(Namespace.ACE_OCN_PERMIT_TO_TRANSFER)
  const translatedTextsObject = makeTranslatedTextsObject()
  const billOfLading = useWatch({ name: 'billOfLading' })
  const manifestId = useWatch({ name: 'manifestHeaderId' })
  const portOfDischarge = useWatch({ name: 'portOfDischarge' })
  const {
    fetchRecords
  } = useServices()
  const [massUpdateOpen, setMassUpdateOpen] = useState(false)
  const [selectedBills, setSelectedBills] = useState([])

  const isIncomplete = (row) =>
    !row.firmsCode || !row.bondedCarrierType || !row.bondedCarrier
 
const prevPortRef = useRef()

useEffect(() => {
  const currentPort = portOfDischarge
  const prevPort = prevPortRef.current

  if (prevPort !== undefined && currentPort !== prevPort) {
    const currentBols = getValues('billOfLading') || []

    const updatedBols = currentBols.map((bill) => ({
      ...bill,
      firmsCode: ''
    }))

    setValue('billOfLading', updatedBols)
    setBillOfLadingDirty(true)
  }

  prevPortRef.current = currentPort
}, [portOfDischarge])


  function makeTranslatedTextsObject() {
   
      let billNumber = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.BILL_OF_LADING_NUMBER
      )
      let firmsCode = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.FIRMS_CODE
      )
      let bondedCarrierType = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER_TYPE
      )
      let bondedCarrier = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER
      )
      let containerNumber = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.CONTAINER_NUMBER
      )
      let quantity = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.QUANTITY
      )
      let remarks = translate(
        Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
        AceOcnPermitToTransferKeys.BillOfLading.REMARKS
      )

    return {
      //billOfLading,
      billNumber,
      firmsCode,
      bondedCarrierType,
      bondedCarrier,
      containerNumber,
      quantity,
      remarks
    }
  }

  const columns = [
    {
      title: translatedTextsObject.billNumber,
      field: 'billNumber',
      filterConfig: { type: 'textfield' },
      render: (rowData) => {
        const firmsCode = String(rowData.firmsCode ?? '').trim()
        const bondedCarrier = String(rowData.bondedCarrier ?? '').trim()
        const bondedCarrierType = String(rowData.bondedCarrierType ?? '').trim()
 
        const shouldHighlight = !firmsCode.trim() || !bondedCarrier.trim() || !bondedCarrierType.trim()
 
        return (
          <Typography style={{ color: shouldHighlight ? 'red' : 'inherit' }}>
            {rowData.billNumber}
          </Typography>
        )
      }
    },
    {
      title: translatedTextsObject.firmsCode,
      field: 'firmsCode',
      filterConfig: { type: 'textfield' }
    },
    {
      title: translatedTextsObject.bondedCarrierType,
      field: 'bondedCarrierType',
      filterConfig: { type: 'textfield' }
    },
    {
      title: translatedTextsObject.bondedCarrier,
      field: 'bondedCarrier',
      filterConfig: { type: 'textfield' }
    }
  ]

  function handleAddBillOfLading(data) {
    const billOfLading = [...getValues('billOfLading'), data].map(
      (bill, index) => ({ ...bill, _id: index + 1 })
    )

    setValue('billOfLading', billOfLading)
    setDialog({ open: false, billOfLading: null })
    setBillOfLadingDirty(true)
  }

  function handleDeleteBillOfLading(data) {
    const billOfLading = [...getValues('billOfLading')].filter((bill) =>
      bill.id ? bill.id !== data.id : bill._id !== data._id
    )

    setValue('billOfLading', billOfLading)
    setBillOfLadingDirty(true)
  }

  function handleEditBillOfLading(data) {
    const billOfLading = [...getValues('billOfLading')]
    const index = billOfLading.findIndex((bill) =>
      bill.id ? bill.id === data.id : bill._id === data._id
    )

    billOfLading[index] = data

    setValue('billOfLading', billOfLading)
    setDialog({ open: false, billOfLading: null })
    setBillOfLadingDirty(true)
  }
 
  function handleCreatePTTFromManifest() {
    if (!manifestId) {
      alert('Manifest ID is missing.')
      return;
    }
 
    fetchRecords.execute(
      AceOcnBillofladingApiUrls.GET,
      {
        filters: [
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'manifestId', operator: EQUAL, value: manifestId },
          { field: 'status', operator: EQUAL, value: 1000 }
        ]
      },
      (response) => {
        const acceptedBols = response?.content || [];
        if (!acceptedBols.length) {
          alert('No accepted Bill of Lading records found for the manifest.')
          return;
        }
 
        const existingBols = getValues('billOfLading') || [];
 
        const duplicateBols = acceptedBols.filter((incoming) =>
          existingBols.some((existing) => existing.billNumber === incoming.billNumber)
        );
 
        if (duplicateBols.length > 0) {
          const duplicateBillNumbers = duplicateBols.map(b => b.billNumber).join(', ');
          const confirmMessage = `The following Bill(s) of Lading already exist: ${duplicateBillNumbers}. Do you want to continue adding them?`;
          const confirmed = window.confirm(confirmMessage);
 
          if (!confirmed) {
            return;
          }
        }
        const startIndex = existingBols.length;
        const newBillOfLadingList = acceptedBols.map((item, idx) => {
          const firstContainer = item.containerDetails?.[0];
          return {
            _id: startIndex + idx + 1,
            billNumber: item.billNumber,
            containerNumber: firstContainer?.containerNumber || '',
            quantity: item.totalPackages,
          };
        });
 
        const updatedList = [...existingBols, ...newBillOfLadingList];
 
        setValue('billOfLading', updatedList);
        setBillOfLadingDirty(true);
        alert('Permit To Transfer records created from Manifest.')
      },
      (error) => {
        console.error(error);
        alert('Failed to load Bill of Lading from Manifest.');
      }
    );
  }
 
 function handleMassUpdateSave(updatedSelectedBills) {
  const currentBills = getValues('billOfLading') || [];

  const mergedBills = currentBills.map((bill) => {
    const billId = bill.id || bill._id;

    const partialUpdate = updatedSelectedBills.find(
      (updated) => (updated.id || updated._id) === billId
    );

    if (!partialUpdate) return bill;
    const updatedFields = {};
    if ('firmsCode' in partialUpdate) {
      updatedFields.firmsCode = partialUpdate.firmsCode;
    }
    if ('bondedCarrierType' in partialUpdate) {
      updatedFields.bondedCarrierType = partialUpdate.bondedCarrierType;
    }
    if ('bondedCarrier' in partialUpdate) {
      updatedFields.bondedCarrier = partialUpdate.bondedCarrier;
    }

    return {
      ...bill,
      ...updatedFields,
    };
  });

  setValue('billOfLading', mergedBills);
  setBillOfLadingDirty(true);
  setMassUpdateOpen(false);
  setSelectedBills([]); 
}
 
  return (
    <Card variant='outlined'>
      {billOfLading?.some(isIncomplete) && (
        <Box p={2}>
          <Typography color="error" variant="body2">
            Some Bills of Lading are incomplete and highlighted in red. Please complete all required fields to submit.
          </Typography>
        </Box>
      )}
      <LocalTable
        actions={[
          {
            buttonProps: { size: 'medium', color: 'secondary' },
            icon: ['fal', 'plus-circle'],
            label: 'Add Permit to Transfer',
            onClick: () => setDialog({ open: true, billOfLading: null })
          },
          ...(manifestId
            ? [
              {
                buttonProps: { size: 'medium', color: 'primary' },
                icon: ['fal', 'file-import'],
                label: 'Create Permit To Transfer From Manifest',
                onClick: handleCreatePTTFromManifest
              }
            ]
    : []),
          {
            buttonProps: {
              size: 'medium',
              color: 'primary',
              disabled: selectedBills.length === 0
            },
            icon: ['fal', 'edit'],
            label: 'Mass Update',
            onClick: () => setMassUpdateOpen(true)
          }
        ]}
        columns={columns}
        data={billOfLading?.map((bill, index) => ({
          ...bill,
          _id: bill._id || bill.id || index 
        }))}
        header={
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography style={{ fontWeight: 600 }}>
                {translatedTextsObject.billOfLading}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box display='flex' justifyContent='flex-end'>
              </Box>
            </Grid>
          </Grid>
        }
        rowActions={[
          {
            icon: ['fal', 'pen'],
            onClick: (rowData) =>
              setDialog({ open: true, billOfLading: rowData }),
            tooltip: () => 'Edit'
          },
          {
            icon: ['fal', 'trash'],
            onClick: handleDeleteBillOfLading,
            tooltip: () => 'Delete'
          }
        ]}
        rowStyle={(rowData) => {
          if (isIncomplete(rowData)) {
            return { backgroundColor: '#ffe6e6' }
          }
          return {}
        }}
        select
        selectActions={[
          {
            icon: ['fal', 'edit'],
            label: 'Mass Update',
            tooltip: 'Mass Update',
            onClick: (selectedRows) => {
              setSelectedBills(selectedRows)
              setMassUpdateOpen(true)
            },
            buttonProps: {
              color: 'primary',
              variant: 'outlined'
            }
          }
        ]}
      />
      <DialogForm
        formProperties={{
          ...BillOfLadingFormProperties,
          Fields: (fieldProps) => (
            <BillOfLadingFormProperties.Fields
              {...fieldProps}
              portOfDischarge={portOfDischarge}
            />
          )
        }}
        fullWidth
        maxWidth='md'
        open={dialog.open}
        onClose={() => setDialog({ open: false, billOfLading: null })}
        onSubmit={
          dialog.billOfLading ? handleEditBillOfLading : handleAddBillOfLading
        }
        title={`${dialog.billOfLading ? 'Edit' : 'Add'} Permit to transfer`}
        value={dialog.billOfLading}
      />
      <MassUpdateDialog
        open={massUpdateOpen}
        onClose={() => setMassUpdateOpen(false)}
        onSave={handleMassUpdateSave}
        selectedBills={selectedBills}
        translatedTextsObject={translatedTextsObject}
        portOfDischarge={portOfDischarge}
      />
    </Card>
  )
}

export default BillOfLadingPTTSection
